import { RootState } from './../../app/store';
import { RoleTypeEnum } from './roleTypeEnums';

export const selectUser = (state: RootState) => state.currentUser;
export const selectAccessToken = (state: RootState) => state.currentUser.accessToken || null;
export const selectRefreshToken = (state: RootState) => state.currentUser.refreshToken || null;
export const selectUserRoles = (state: RootState) => state.currentUser.roles ?? [];
export const selectIsSuperAdmin = (state: RootState) => (state.currentUser.roles ?? []).includes(RoleTypeEnum.SUPER_ADMIN);
export const selectIsRunner = (state: RootState) => (state.currentUser.roles ?? []).includes(RoleTypeEnum.RUNNER);
